module.exports = __webpack_public_path__ + "static/media/ic_close_white.902731e0.svg";